import axios from 'axios';
import { apiPaths, preciousChildPaths } from 'constants/path';
import { tokenHeader } from 'functions/apiFunctions';
import { GetVerifyAiAccessResponse } from 'models/MindUp/MindUpApiTypes';
import { purchaseCounselingResponse, purchaseCounselingRqData } from 'models/MindUp/purchaseCounselingApiTypes';

class MindUpMicsApi {
    async verifyAiAccess(voucherCode: string, diagnosisId: string, token: string): Promise<GetVerifyAiAccessResponse> {
        try {
            const response = await axios.get(apiPaths.verifyAiAccess + voucherCode + '/' + diagnosisId, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}
export const mindupMicsApi = new MindUpMicsApi();
